import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { Notification, NotificationsPreviewResponseDto } from '../../types/notifications';

const ENDPOINT = 'external/pinned_flashes/preview';

export const getUserNotifications = async (route: string): Promise<Notification[]> => {
    try {
        const url = `${route}/${ENDPOINT}`;
        const fetcher = () => axios.get<NotificationsPreviewResponseDto>(url);
        const { data } = await statsFunctionWrapper(fetcher, 'jtbd.order_updates.get_user_notifications')();

        return data.notifications;
    } catch (error: any) {
        logger.error(error, { description: 'Failed to user notifications', source: 'getUserNotifications', route });

        return [];
    }
};
